export default __webpack_public_path__ + "static/media/matic-token-inverted-icon.26e39f24.png";